export default __webpack_public_path__ + "static/media/4691@3x.d985e4db.png";